export const COMPLETE = 'Complete';
export const DUE = 'Due';
export const UPCOMING = 'Upcoming';

export const MAINTENANCE_NOTIFICATION_STATUSES = [COMPLETE, DUE, UPCOMING];

export const DUE_DISPLAY = { progress: 'active-dm', text: 'active-dm' };
export const ONE_TIME_COMPLETE_DISPLAY = {
  progress: 'success',
  text: 'success',
};
export const NEUTRAL_DISPLAY = { progress: 'dark', text: 'muted' };
export const UPCOMING_DISPLAY = { progress: 'warning-yellow', text: 'muted' };
export const INSTANCE_COLOR_MAP = new Map([
  [COMPLETE, { false: ONE_TIME_COMPLETE_DISPLAY, true: NEUTRAL_DISPLAY }],
  [DUE, { false: DUE_DISPLAY, true: DUE_DISPLAY }],
  [UPCOMING, { false: UPCOMING_DISPLAY, true: UPCOMING_DISPLAY }],
  [undefined, { false: NEUTRAL_DISPLAY, true: NEUTRAL_DISPLAY }],
]);

export const TAB_NAV_MAP = new Map([
  [DUE, 'Overdue'],
  [UPCOMING, UPCOMING],
  [COMPLETE, 'Historical'],
]);
